<!-- Page Header Start-->
<div class="page-header" [class.close_icon]="navServices.collapseSidebar">
    <nav class="navbar m-0" [hidden]="statutLayout()">
        <div
            class="container-fluid d-flex justify-content-between align-items-center flex-wrap px-3 py-2 mr-10"
        >
            <div class="d-flex align-items-center gap-3">
                <h3 class="sidebar-tenant">
                    <span class="legende"><b>KANIS LOGISTICS CI</b></span>
                </h3>
            </div>

            <div class="d-flex gap-4 align-items-center">
                <div style="padding-top: 0.5rem">
                    <i
                        class="pi pi-refresh header-icon"
                        title="Rafraîchir"
                        (click)="handleRefreshNotification()"
                    ></i
                    >&nbsp;
                    <i
                        class="pi pi-bell header-icon"
                        pBadge
                        [value]="
                            (notificationCount$ | async) == 0
                                ? ''
                                : (notificationCount$ | async)
                        "
                        severity="{{
                            (notificationCount$ | async) ? 'danger' : ''
                        }}"
                        (click)="OnGoNotif()"
                        title="Notifications"
                    ></i>
                </div>
                <div>
                    <ul class="nav-menus mb-0">
                        <li class="profile-nav onhover-dropdown p-0">
                            <app-my-account></app-my-account>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </nav>
</div>